<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="rest-api md-grey-page website-edit">
		<div class="page-banner"></div>
		<section class="rest-api__section container-white">
			<div class="edit-page margin-top-60 text-center" v-if="!loaded">
				<p class="loading-text">Loading rest Applicant Import<span>.</span><span>.</span><span>.</span></p>
			</div>
			<div class="" v-if="loaded">
				<h2 class="text-center">Applicant Import</h2>
        <div class="text-center description">
          To start importing your applicants directly from your portals, please contact the portal and change the email address where the leads are sent to the addresses below depending on the portal.<br>
Or, you can log in to your portal account and do this manually by copy & pasting the addresses.
        </div>
				<div class="">
					<div class="edit-page__content">
						<h3 class="margin-top-30 text-center">Portals</h3>
            <div v-for="(i, portal) in portals" class="text-left mdc-layout-grid__inner">
              <div class="field has-addons mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone">
                {{ portals[portal] }}:
              </div>
              <div class="field has-addons mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-2-phone">
                <input type="text" readonly="readonly" class="input" :value="portalUrl(portal)" style="width:240px" v-clipboard:copy="portalUrl(portal)"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError" />
              </div>
              <div class="field has-addons mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone text-right">
                <span v-if="feedback[portal] != ''" v-html="feedback[portal]" class="copied"></span>
              </div>


            </div>
					</div>
				</div>
				<div class="">
					<div class="edit-page__content">
            <h3 class="margin-top-30 text-center">Forward to email</h3>
            <input type="email" class="input" v-model="emailto" style="width:220px" />
						<div class="mdc-form-field width-100 text-center">
							<div class="mdc-checkbox">
								<input id="copyfromPortal" value="yes" class="mdc-checkbox__native-control" type="checkbox" v-model="copyfromPortal">
								<div class="mdc-checkbox__background"></div>
							</div>
							<label for="copyfromPortal">Get the original email from Portals</label>
						</div>
            <button class="input button" @click.prevent="updateAppImportEmail">Save</button>
          </div>
        </div>



			</div>
		</section>
	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';

export default {
	data: function() {
		return {
			loaded: false,
      company: {},
      emailto: '',
			copyfromPortal: false,
      portals: {
        "rightmove": "Rightmove",
        "zoopla": "Zoopla",
        "otm": "OnTheMarket",
      },
      feedback: {
        "rightmove": "",
        "zoopla": "",
        "otm": ""
      }
		}
	},
	mixins: [utils],
  computed: {
  },
	mounted: async function() {

   this.company = await api({endpoint: this.config.services.companyDetails, method: 'GET'});
   if (this.company.companyDetails && this.company.companyDetails.appimpEmail && this.company.companyDetails.appimpEmail != '') {
     this.emailto = this.company.companyDetails.appimpEmail;
		 this.copyfromPortal = this.company.companyDetails.appimpCopyFromPortal ? true : false;
   } else if (this.company.companyDetails && this.company.companyDetails.email && this.company.companyDetails.email != '') {
     this.emailto = this.company.companyDetails.email;
		 this.copyfromPortal = this.company.companyDetails.appimpCopyFromPortal ? true : false;
   }
	 this.loaded = true;
	},
	methods: {
    updateAppImportEmail: async function() {
      try {
   	    this.loaded = false;
				console.log("this.copyfromPortal",this.copyfromPortal);
        const saved = await api({endpoint: this.config.services.companies, path: '/update', method: 'POST', body: {
          appimpEmail: this.emailto,
					appimpCopyFromPortal: this.copyfromPortal ? true : false
        }});
     	  this.loaded = true;
      } catch(e) {
        console.log('Error saving',e.message);
     	  this.loaded = true;
      }
    },
    portalUrl: function(portalId) {
      let companyId;
      if (this.$store.getters.adminCompanyId && this.$store.getters.adminCompanyId !== this.$store.getters.companyId) {
        companyId = this.$store.getters.adminCompanyId;
      } else {
        companyId = this.$store.getters.companyId;
      }
      if (process.env.NODE_ENV == 'production') {
        return `${portalId}+${companyId}@bestagent.online`;
      } else {
        return `test-${portalId}+${companyId}@bestagent.online`;
      }
    },
    onCopy: function (e) {
      const that = this;
      if (e.text.indexOf('rightmove+') !== -1) {
        this.feedback.rightmove = "Copied!";
        setTimeout(function(){
          that.feedback.rightmove = "";
        },7000);
      }
      if (e.text.indexOf('zoopla+') !== -1) {
        this.feedback.zoopla = "Copied!";
        setTimeout(function(){
          that.feedback.zoopla = "";
        },7000);
      }
      if (e.text.indexOf('otm+') !== -1) {
        this.feedback.otm = "Copied!";
        setTimeout(function(){
          that.feedback.otm = "";
        },7000);
      }
    },
    onError: function (e) {
      if (e.text.indexOf('rightmove') !== -1) {
        this.feedback.rightmove = "Error!";
      }
      if (e.text.indexOf('zoopla') !== -1) {
        this.feedback.zoopla = "Error!";
      }
      if (e.text.indexOf('onthemarket') !== -1) {
        this.feedback.otm = "Error!";
      }
    }
	}
}
</script>
<style>
.copied {
  color: #7e7e7e;
  border: 1px solid #7e7e7e;
  padding:2px;
  border-radius: 5px;

}
</style>



// WEBPACK FOOTER //
// src/pages/Settings-Applicant-Import.vue